import { createSlice } from '@reduxjs/toolkit';
import { UnsavedChangesProps } from '../../components/UnsavedChanges';

const initialStateUS: UnsavedChangesProps = {
	isDirty: false,
	isModalOpen: false,
	isNavigationAllowed: true,
	handleCancel: null,
	handleConfirm: null,
};

const unSavedChangesReducerSlice = createSlice({
	name: 'unSavedChangesReducer',
	initialState: initialStateUS,
	reducers: {
		setDirty(state, action) {
			return { ...action.payload };
		},
		resetDirty() {
			return {
				isDirty: false,
				isModalOpen: false,
				isNavigationAllowed: false,
				handleCancel: null,
				handleConfirm: null,
			};
		},
	},
});

export const { setDirty, resetDirty } = unSavedChangesReducerSlice.actions;
export default unSavedChangesReducerSlice.reducer;
